(function dynamicTextDirectiveDefinition() {
    'use strict';

    angular.module('CustomControlText', [])
        .directive('dynamicText', ['$translate', function () {
            return {
                replace: true,
                restrict: 'E',
                templateUrl: '/app/directives/custom-control-text/custom-control-text-template.html',
                controller: [
                    '$scope', '$filter', function ($scope, $filter) {
                        $scope.maxLength = null;
                        $scope.minLength = null;
                        $scope.textLength = 0;

                        $scope.showMaxLengthWarning = false;
                        $scope.showMinLengthWarning = false;
                        $scope.showCharactersLeft = false;
                        $scope.textAreaClass = 'ta-h-1';
                        $scope.mask = $scope.data.mask;

                        if ($scope.mask) {
                            $scope.mask = $scope.mask.split('0').join('9');
                            $scope.mask = $scope.mask.split('S').join('A');
                        }

                        //MaskPlaceHolder puede ser Undefined, por eso la comparacion simple
                        if ($scope.data.maskPlaceHolder != null) {
                            $scope.data.maskPlaceHolder = $scope.data.maskPlaceHolder.split('0').join('#');
                            $scope.data.maskPlaceHolder = $scope.data.maskPlaceHolder.split('9').join('#');
                            $scope.data.maskPlaceHolder = $scope.data.maskPlaceHolder.split('S').join('A');
                        }

                        if ($scope.data.metadataAttributes && $scope.data.metadataAttributes.length > 0) {
                            var maxValue = $filter('filter')($scope.data.metadataAttributes, { type: 'maxlength' }, true);

                            if (maxValue && maxValue.length > 0) {
                                $scope.maxLength = parseInt(maxValue[0].value) === 0 ? null : parseInt(maxValue[0].value);
                            }

                            $scope.maxLength = $scope.data.mask ? $scope.data.mask.length : $scope.maxLength;

                            var minValue = $filter('filter')($scope.data.metadataAttributes, { type: 'minlength' }, true);
                            if (minValue && minValue.length > 0) {
                                $scope.minLength = parseInt(minValue[0].value);
                            }

                            $scope.minLength = $scope.data.mask ? $scope.data.mask.length - 1 : $scope.minLength;

                            if ($scope.data && $scope.data.metadataIsRequired) {
                                $scope.showCharactersLeft = $scope.maxLength > 0;
                            }

                            $scope.textAreaClass = $scope.maxLength > 0 && $scope.maxLength <= 20 ? 'ta-h-1' :
                                $scope.maxLength > 20 && $scope.maxLength <= 30 ? 'ta-h-2' :
                                    $scope.maxLength > 30 ? 'ta-h-2' : 'ta-h-1';

                            if ($scope.data && $scope.data.metadataIsRequired) {
                                if ($scope.minLength > 0) {
                                    $scope.showMinLengthWarning = $scope.textLength <= 0 || ($scope.textLength < $scope.minLength && $scope.textLength !== 0);
                                }
                            }
                        }

                        $scope.control = function (data) {
                            if (!$scope.mask) {
                                $scope.textLength = document.getElementById(data.metadataId).textLength;

                                if ($scope.textLength > 0) {
                                    $scope.showCharactersLeft = $scope.maxLength > 0;
                                } else {
                                    $scope.showCharactersLeft = false;
                                }

                                if ($scope.maxLength > 0) {
                                    $scope.showMaxLengthWarning = $scope.textLength > $scope.maxLength && $scope.textLength !== 0;
                                }
                                if ($scope.minLength > 0) {
                                    if ($scope.data && !$scope.data.metadataIsRequired && $scope.textLength === 0) {
                                        $scope.showMinLengthWarning = false;
                                    } else {
                                        $scope.showMinLengthWarning = $scope.textLength <= 0 || ($scope.textLength < $scope.minLength && $scope.textLength !== 0);
                                    }
                                }
                            }
                        };
                    }
                ]
            };
        }]);

    angular.module('CustomControlText')
        .directive('dynamicFilterText', ['$translate', function () {
            return {
                templateUrl: '/app/directives/custom-control-text/custom-control-filter-text-template.html',
                replace: true,
                restrict: 'E',
                controller: [
                    '$scope', function ($scope) {
                        $scope.mask = $scope.data.mask;

                        if ($scope.mask) {
                            $scope.mask = $scope.mask.split('0').join('9');
                            $scope.mask = $scope.mask.split('S').join('A');
                        }

                        //MaskPlaceHolder puede ser Undefined, por eso la comparacion simple
                        if ($scope.data.maskPlaceHolder != null) {
                            $scope.data.maskPlaceHolder = $scope.data.maskPlaceHolder.split('0').join('#');
                            $scope.data.maskPlaceHolder = $scope.data.maskPlaceHolder.split('9').join('#');
                            $scope.data.maskPlaceHolder = $scope.data.maskPlaceHolder.split('S').join('A');
                        }

                        if ($scope.data && !$scope.data.metadataSearchTypeFrom) {
                            $scope.data.metadataSearchTypeFrom = 'EqualIgnoreCase';
                        }
                    }
                ],
                link: function ($scope, element, attrs) {
                    $scope.filterNullValue = attrs.filternullvalue;
                }
            };
        }]);
})();